module.exports = require("prismjs");